export const showUser = (state) => state.user
